"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgFilePlus = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M26 13a1 1 0 01.707.293l6 6A1 1 0 0133 20v12a3 3 0 01-3 3H18a3 3 0 01-3-3V16a3 3 0 013-3h8zm-1 2h-7a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V22h-5a1 1 0 01-1-1v-6zm-1 8a1 1 0 011 1v2h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2h-2a1 1 0 010-2h2v-2a1 1 0 011-1zm3-6.585V20h3.586L27 16.415z",
    id: "file-plus_svg__a"
  }));
};

var _default = SvgFilePlus;
exports.default = _default;